import { gsap } from "gsap/all";
import { ScrollTrigger, SplitText } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, SplitText);

import { Accordion } from "../components/accordion";
import { sliderMobile, initializeSlider } from "../components/Sliders";
import { CountUp } from "../components/CountUp";

document.addEventListener("DOMContentLoaded", (e) => {
	Accordion.init();

	CountUp.init({
		selector: ".key-figure__number",
		once: true,
		threshold: 0.3,
	});

	// Tous les groupes de cards
	const cards_cares_groups = document.querySelectorAll(".cards-group--cares");

	cards_cares_groups.forEach((group) => {
		const seeMoreBtn = group.querySelector(".js-show-cards");
		if (!seeMoreBtn) return;

		const hiddenRows = group.querySelectorAll(".cards-group__row.is-hidden");
		const replacementCard = group.querySelector(".js-show-cards-replacement");
		if (!hiddenRows.length && !replacementCard) return;
		const hideOnClick = seeMoreBtn.getAttribute("data-hide-on-click") === "true";

		// Récupérer les labels depuis les attributs data
		const labelTarget = seeMoreBtn.querySelector(".js-show-cards-label");
		const labelMore = seeMoreBtn.getAttribute("data-label-more") || (labelTarget ? labelTarget.textContent.trim() : seeMoreBtn.textContent.trim());
		const labelLess = seeMoreBtn.getAttribute("data-label-less");

		seeMoreBtn.addEventListener("click", function () {
			if (hideOnClick) {
				hiddenRows.forEach((row) => row.classList.remove("is-hidden"));
				if (replacementCard) {
					replacementCard.style.display = "";
				}
				seeMoreBtn.style.display = "none";
				return;
			}

			const isHidden = hiddenRows[0].classList.contains("is-hidden");

			hiddenRows.forEach((row) => row.classList.toggle("is-hidden"));

			// Changer le texte selon l'état actuel
			if (labelTarget) {
				labelTarget.textContent = isHidden ? labelLess : labelMore;
			} else {
				seeMoreBtn.textContent = isHidden ? labelLess : labelMore;
			}
		});
	});

	// Animate headings
	let splits = [];
	let timelines = [];

	const createSplit = () => {
		// Reset si déjà créé
		splits.forEach((s) => s.revert());
		timelines.forEach((t) => t.revert());
		splits = [];
		timelines = [];

		// Boucle sur tous les headings
		document.querySelectorAll(".animated-heading__text").forEach((heading) => {
			// Split des mots
			const split = new SplitText(heading, {
				type: "words",
				wordsClass: "word",
			});
			splits.push(split);

			// Timeline pour chaque heading
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: heading.closest(".vc_row"), // déclenche par section
					start: "top 60%",
					end: "bottom 50%",
					scrub: 0.5,
				},
			});

			tl.to(split.words, {
				color: "#293853",
				duration: 0.4,
				ease: "power1.out",
				stagger: 0.1,
			});

			timelines.push(tl);
		});
	};

	// Création initiale
	createSplit();

	// Recréation au resize
	const debouncer = gsap.delayedCall(0.2, createSplit).pause();
	window.addEventListener("resize", () => debouncer.restart(true));

	// Animate background sections
	gsap.utils.toArray(".vc_section:is(.has-logo-bkg)").forEach((section) => {
		gsap.to(section, {
			"--gsap-y": "90%",
			ease: "linear",
			scrollTrigger: {
				trigger: section,
				start: "top 110%",
				end: "bottom top",
				scrub: 1,
			},
		});
	});

	// Animate pics in plx_row (desktop/tablette uniquement)
	const picParallaxValues = {
		1: { fromY: 12, toY: -8 },
		2: { fromY: -8, toY: 20 },
		3: { fromY: 20, toY: -16 },
	};

	gsap.matchMedia().add("(min-width: 769px)", () => {
		document.querySelectorAll(".pics-grid").forEach((grid) => {
			grid.querySelectorAll(".pics-grid__item").forEach((item) => {
				const values = picParallaxValues[item.dataset.pic];
				if (!values) return;

				gsap.fromTo(
					item,
					{ yPercent: values.fromY },
					{
						yPercent: values.toY,
						ease: "power1.out",
						scrollTrigger: {
							trigger: grid,
							start: "top bottom",
							end: "bottom top",
							scrub: true,
						},
					},
				);
			});
		});
	});

	const picFullObjs = document.querySelectorAll(".pic-full");

	if (picFullObjs.length > 0) {
		picFullObjs.forEach((pic) => {
			gsap.to(pic, {
				clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
				ease: "none",
				scrollTrigger: {
					trigger: pic.closest(".vc_section"),
					start: "-20% bottom",
					end: "70% 50%",
					scrub: 1,
				},
			});
		});
	}

	// Make slider from reviews
	const sliders_reviews = document.querySelectorAll(".reviews-slider");
	if (sliders_reviews) {
		sliders_reviews.forEach((slider) => {
			initializeSlider(slider, {
				minSlidesToInit: 2,
				loop: true,
				autoplay: {
					enabled: true,
					delay: 4000,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				},
				breakpoints: {
					0: {
						slidesPerView: 1.2,
						spaceBetween: 16,
						slidesOffsetAfter: 24,
						slidesOffsetBefore: 24,
					},
					768: {
						slidesPerView: 2.2,
						spaceBetween: 16,
						slidesOffsetAfter: 24,
						slidesOffsetBefore: 24,
					},
					1000: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					1061: {
						slidesPerView: 4,
						spaceBetween: 16,
					},
				},
			});
		});
	}

	// Init slider on mobile
	const sliders_caresGroup = document.querySelectorAll(".js-slider-sm-cares-group");
	sliders_caresGroup.forEach((slider) => {
		sliderMobile.init({
			selector: slider,
			slidesPerView: 2.3,
			spaceBetween: 16,
			slidesOffsetAfter: 24,
			slidesOffsetBefore: 24,
			bleed: false,
		});
	});

	const sliders_keyFigures = document.querySelectorAll(".key-figures");
	sliders_keyFigures.forEach((slider) => {
		sliderMobile.init({
			selector: slider,
			spaceBetween: 16,
			slidesPerView: 2,
			loop: true,
			autoplay: {
				enabled: true,
				delay: 0,
				pauseOnMouseEnter: true,
				disableOnInteraction: false,
			},
			centerInsufficientSlides: true,
			speed: 2000,
			pagination: false,
		});
	});
});
